/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import http from './index';

let globalFlagForUserList = true;

export const healthCheck = () => http.get('/health-check');
export const postFeedInput = (params) =>
  http.post('/winflows_calculations', params);
export const postWinflowsSolveOrder = (params) =>
  http.post('/winflows_solve_order', params);
export const CIPCalculatorApi = (params) =>
  http.post('/cip_calculations', params);
export const getWinflowsFileList = (params1, params2) =>
  http.get(`/winflows_get_file_list?param1=${params1}&param2=${params2}`);
// export const getWinflowsFileContent = (params1, params2, params3) =>
//   http.get(`/winflows_get_winfile_content?param1=${params1}_${params2}&param2=${params1}&param3=${params3}`);

export const getWinflowsFileContent = (params1, params2, params3) =>
  http.get(`/winflows_get_winfile_content?param1=${params1}_${params2}&param2=${params1}&param3=${params3}`);

export const getWinflowsFileContent_folder = (folder, params1, params2, params3) =>
  http.get(`/winflows_get_winfile_content?param1=${folder}${params1}_${params2}&param2=${params1}&param3=${params3}`);
// http.get(`/winflows_get_winfile_content?param1=${folder}/${params1}_${params2}&param2=${params1}&param3=${params3}`);
export const VerifyEmail = (params) =>
  http.post('/verifyEmail', params);

export const getWinflowsFileContent_preconfigFile = (params1) =>
  http.get(`/winflows_get_winfile_content?param1=${params1}&param2=''&param3=''`);
export const getWinflowsFileContent_FlowsheetWizard = (params1) =>
  http.get(`/winflows_get_winfile_content?param1=${params1}&param2=''&param3=''`);
export const getWinflowsFileContent_units = (params1) =>
  http.get(`/winflows_get_winfile_content?param1=${params1}&param2=''&param3=''`);
export const saveWinflowsFileContent = (params1, params2, params3, params4) =>
  http.post(`/winflows_file_save?param1=${params1}&param2=${params2}&param3=${params3}`, params4);
export const WinflowsFileManagmentAPI = (params) => http.post('/winfiles_files_managment', params);
export const getEDIDataOnChange = (params) =>
  http.post('/winflows_edi_calculations', params);
export const getArgoWordDoc = (params) =>
  http.post('/googleDocReport', params);
export const unitConvertion = () =>
  http.post('/unit_conversion?param1=100&param2=m3/hr&param3=m3/day');
export const defaultUnits = (params) => http.post('/default_units', params);
export const getFlowSheet = (params) => http.post('/flowsheet_selection', params);
export const dbTransaction = (params) => http.post('/db_transactions?param1=""', params);
export const roMachine = (params) => http.post('/db_transactions?param1=ROMachine', params);
export const getImagePath = (params) => http.post('/WinLambda1', params);

export const download_spec_file = (params1) =>
  http.get(`/download-spec-file?param1=${params1}`);

// for Admin by Abhishek on 12-Jan-24
export const getAdminData = (params) => http.post('/winflows_db_update', params);
export const addAdminData = (params) => http.post('/winflows_db_update', params);
export const updateAdminData = (params) => http.post('/winflows_db_update', params);
export const deleteAdminData = (params) => http.post('/winflows_db_update', params);

// export const saveFeedInputs = (params) => http.post('/save_feed_input_file', params);
// export const deleteFeedInputs = (params) => http.post('/delete_feed_input', params);
// export const getFeedInputByFilename = (params) => http.post('/get_feed_input_by_filename', params);
// export const getAllFeedInputByFilename = (params) => http.get('/get_feed_input_by_filename', params);
// export const calculateMakeDecodepairs = (params) => http.post('/calculate_make_decode_pairs', params);
export const downloadFile = (params) => http.post('/winflows_csv_file_write', params, true);
// http.post('https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/winflows_csv_file_write', params, true);

// http.post('https://h6iuyle7bf.execute-api.us-east-1.amazonaws.com/v0/download', params, true);

export const downloadFiledoc = (params) => http.get('/googleDocReport', params, true);
// http.get('https://m99wyqg41j.execute-api.us-east-1.amazonaws.com/v0/googleDocReport', params, true);

export const deleteFile = (params) =>
  http.del('https://h6iuyle7bf.execute-api.us-east-1.amazonaws.com/v0/delete-file', params, true);
// export const checkFileExists = (params) =>
//   http.get('https://4qw7n6f4eg.execute-api.us-east-1.amazonaws.com/dev/check-file-exist', params, true);
export const checkFileExists = (params1, params2, params3) =>
  http.get(`/checkFileExist?param1=${params1}&param2=${params2}&param3=${params3}`);
// commented by chandrashekhar because unused code. 6-May-2025 START
// export const getRoFeed = (params) =>
//   http.get('https://4qw7n6f4eg.execute-api.us-east-1.amazonaws.com/dev/get-ro-feed', params, true);
// commented by chandrashekhar because unused code.  6-May-2025 START
export const getUserListData = () => {
  if (globalFlagForUserList) {
    globalFlagForUserList = false;
    const UserListData = sessionStorage.getItem('UserListData');
    if (UserListData);
    else {
      http.post('https://h7n54lfsvk.execute-api.us-east-1.amazonaws.com/live/list', {}, true).then((response) => {
        response.data.UserList.sort((a, b) => {
          return a.OEMAIL > b.OEMAIL ? 1 : -1;
        });
        sessionStorage.setItem('UserListData', JSON.stringify(response.data.UserList));
      });
    }
  }
};
// export const updateRoFeed = (params) => http.post('/calculate_make_decode_pairs', params);

export const getProjectWinflowsFileList = (params1, params2, page = 1, limit = 30, type = 'my_projects') => {
  return http.get(`/winflows_get_project_file_list?param1=${params1}&param2=${params2}&param3=${page}&param4=${limit}&param5=${type}`);
  // http.get(`/winflows_get_project_file_list?param1=${params1}&param2=${params2}`);
};
export const FetchGoogleSpredSheetData = async (param) => {
  const data = await http.post('/upwGoogleSheet', param);
  return data;
};

export const updateProjectInfoDictIsReadtoTrue = (params1, params2, params3, params4) =>
  http.post(`/winflows_project_file_save?param1=${params1}&param2=${params2}&param3=${params3}`, params4);

export const deleteWinAndProjectFile = (params1, params2, params3) =>
  http.post(`/delete_s3_files?param1=${params1}&param2=${params2}`, params3);

export const fileConversion = (params) => http.post('/file_conversion', params);
export const sign_up = (params) => http.post('/sign_up', params);
export const userTracking = (params) => http.post('/usertracking', params);

export const logWinFileChange = (params) => http.post('/logWinFileChange', params);

export const readPreconfigFilesFromS3 = () => http.get('/read_preconfig_files_from_s3');